import { AiFillSafetyCertificate } from 'react-icons/ai';
import {
  FaAnchor,
  FaBinoculars,
  FaChalkboardTeacher,
  FaClipboardList,
  FaEnvira,
  FaHandPeace,
  FaInfoCircle,
  FaLaptopCode,
  FaLuggageCart,
} from 'react-icons/fa';
import {
  GiAtSea,
  GiCrane,
  GiDrinkMe,
  GiIceBolt,
  GiRank2,
  GiTeacher,
  GiValve,
} from 'react-icons/gi';
import { IoIosPeople } from 'react-icons/io';
import { MdNotificationsActive, MdSupervisorAccount } from 'react-icons/md';
import { RiAlarmWarningFill } from 'react-icons/ri';

// Ranks icons
import Engineer2 from '../Images/icons/all_ranks/2nd_eng.svg';
import Officer2 from '../Images/icons/all_ranks/2nd_off.svg';
import Engineer3 from '../Images/icons/all_ranks/3rd_eng.svg';
import Officer3 from '../Images/icons/all_ranks/3rd_off.svg';
import Engineer4 from '../Images/icons/all_ranks/4th_eng.svg';
import Cadet from '../Images/icons/all_ranks/cadet.svg';
import Captain from '../Images/icons/all_ranks/captain.svg';
import CateringOfficer from '../Images/icons/all_ranks/catering_off.svg';
import ChiefEngineer from '../Images/icons/all_ranks/chief_eng.svg';
import ChiefOfficer from '../Images/icons/all_ranks/chief_off.svg';
import Cook from '../Images/icons/all_ranks/cook.svg';

// General Icons
import Bulletin from '../Images/icons/general/Bulletin.svg';
import Certificate from '../Images/icons/general/certificate.svg';
import ChainBreak from '../Images/icons/general/ChainBreak.svg';
import ChecklistCustom from '../Images/icons/general/checklist.svg';
import CO2 from '../Images/icons/general/CO2.svg';
import Collaborate from '../Images/icons/general/Colaborate.svg';
import Documents from '../Images/icons/general/documents.svg';
import Garbage from '../Images/icons/general/Garbage.svg';
import Guide from '../Images/icons/general/Guide.svg';
import Handbook from '../Images/icons/general/Handbook.svg';
import Like from '../Images/icons/general/Like.svg';
import LinkIcon from '../Images/icons/general/link.svg';
import LockTag from '../Images/icons/general/lock-Tag.svg';
import LockCustom from '../Images/icons/general/lock.svg';
import Manifold from '../Images/icons/general/manifold.svg';
import Manual from '../Images/icons/general/Manual.svg';
import Manuals from '../Images/icons/general/Manuals.svg';
import Meeting2 from '../Images/icons/general/Meeting.svg';
import NOx from '../Images/icons/general/NOx.svg';
import Order from '../Images/icons/general/Order.svg';
import Permit from '../Images/icons/general/Permit.svg';
import Policy2 from '../Images/icons/general/Policy2.svg';
import Poster from '../Images/icons/general/Poster.svg';
import Read from '../Images/icons/general/Read.svg';
import Recycle from '../Images/icons/general/Recycle.svg';
import Signature from '../Images/icons/general/Signature.svg';
import Strategy from '../Images/icons/general/strategy.svg';
//
import Accident from '../Images/icons/general/accident.svg';
import AnchorCustom from '../Images/icons/general/anchor.svg';
import BadFeedback from '../Images/icons/general/bad-feedback.svg';
import BasicTick from '../Images/icons/general/basic-tick.svg';
import BatteryStatusFull from '../Images/icons/general/battery-status-full.svg';
import Battery from '../Images/icons/general/battery.svg';
import Battery2 from '../Images/icons/general/battery2.svg';
import Bell from '../Images/icons/general/bell.svg';
import Binoculars from '../Images/icons/general/binoculars.svg';
import Biohazard from '../Images/icons/general/biohazard.svg';
import BiologicalHazard from '../Images/icons/general/biological-hazard.svg';
import Boss from '../Images/icons/general/boss.svg';
import Buoy from '../Images/icons/general/buoy.svg';
import Businessman from '../Images/icons/general/businessman.svg';
import Businessmen from '../Images/icons/general/businessmen.svg';
import CaptainCap from '../Images/icons/general/captain-cap.svg';
import CaptainCap2 from '../Images/icons/general/captain-cap2.svg';
import CargoShip from '../Images/icons/general/cargo-ship.svg';
import CargoShip2 from '../Images/icons/general/cargo-ship2.svg';
import Caution from '../Images/icons/general/caution.svg';
import Charity from '../Images/icons/general/charity.svg';
import ChatBubbleCustom from '../Images/icons/general/chat-bubble.svg';
import Checked from '../Images/icons/general/checked.svg';
import City from '../Images/icons/general/city.svg';
import Coal from '../Images/icons/general/coal.svg';
import Cogwheel from '../Images/icons/general/cogwheel.svg';
import ConstructionCrane from '../Images/icons/general/construction-crane.svg';
import ContainerCustom from '../Images/icons/general/container.svg';
import Crane from '../Images/icons/general/crane.svg';
import CyberSecurity from '../Images/icons/general/cyber-security.svg';
import Deal from '../Images/icons/general/deal.svg';
import Diesel from '../Images/icons/general/diesel.svg';
import Kone2 from '../Images/icons/general/dork.svg';
import Electricity from '../Images/icons/general/electricity.svg';
import EmergencyCall from '../Images/icons/general/emergency-call.svg';
import EmergencyCall2 from '../Images/icons/general/emergency-call2.svg';
import Emergency from '../Images/icons/general/emergency.svg';
import Exit from '../Images/icons/general/exit.svg';
import Faucet from '../Images/icons/general/faucet.svg';
import FeedbackCustom from '../Images/icons/general/feedback.svg';
import Feedback2 from '../Images/icons/general/feedback2.svg';
import FireAlarm from '../Images/icons/general/fire-alarm.svg';
import FireExit from '../Images/icons/general/fire-exit.svg';
import FireExtinguisherCustom from '../Images/icons/general/fire-extinguisher.svg';
import FireExtinguisher2 from '../Images/icons/general/fire-extinguisher2.svg';
import Fire from '../Images/icons/general/fire.svg';
import Firefighter from '../Images/icons/general/firefighter.svg';
import Firefighter2 from '../Images/icons/general/firefighter2.svg';
import FirstAidKit from '../Images/icons/general/first-aid-kit.svg';
import Flash from '../Images/icons/general/flash.svg';
import Flashlight from '../Images/icons/general/flashlight.svg';
import Freight from '../Images/icons/general/freight.svg';
import Fuel from '../Images/icons/general/fuel.svg';
import GasMask from '../Images/icons/general/gas-mask.svg';
import GasStation from '../Images/icons/general/gas-station.svg';
import Gas from '../Images/icons/general/gas.svg';
import Gas2 from '../Images/icons/general/gas2.svg';
import Gasoline from '../Images/icons/general/gasoline.svg';
import GlobalServices from '../Images/icons/general/global-services.svg';
import Graphic from '../Images/icons/general/graphic.svg';
import H2O from '../Images/icons/general/h2o.svg';
import Healthcare from '../Images/icons/general/healthcare.svg';
import Helmet from '../Images/icons/general/helmet.svg';
import HierarchicalStructure from '../Images/icons/general/hierarchical-structure.svg';
import Hierarchy from '../Images/icons/general/hierarchy.svg';
import Hierarchy2 from '../Images/icons/general/hierarchy2.svg';
import HighVoltage from '../Images/icons/general/high-voltage.svg';
import HouseCustom from '../Images/icons/general/house.svg';
import Hydrant from '../Images/icons/general/hydrant.svg';
import IdCard from '../Images/icons/general/id-card.svg';
import IdeaCustom from '../Images/icons/general/idea.svg';
import InflatableBoat from '../Images/icons/general/inflatable-boat.svg';
import InfoButton from '../Images/icons/general/info-button.svg';
import Info2 from '../Images/icons/general/info2.svg';
import Inspection from '../Images/icons/general/inspection.svg';
import Internet from '../Images/icons/general/internet.svg';
import LeafCustom from '../Images/icons/general/leaf.svg';
import Leak from '../Images/icons/general/leak.svg';
import LifeVest from '../Images/icons/general/life-vest.svg';
import Lifeboat from '../Images/icons/general/lifeboat.svg';
import Lifebuoy from '../Images/icons/general/lifebuoy.svg';
import Lifesaver from '../Images/icons/general/lifesaver.svg';
import Lighthouse from '../Images/icons/general/lighthouse.svg';
import LocationCustom from '../Images/icons/general/location.svg';
import Locations from '../Images/icons/general/locations.svg';
import MechanicalGears from '../Images/icons/general/mechanical-gears.svg';
import Medal from '../Images/icons/general/medal.svg';
import Megaphone from '../Images/icons/general/megaphone.svg';
import MooringPoint from '../Images/icons/general/mooring-point.svg';
import Motor from '../Images/icons/general/motor.svg';
import NoAlcohol from '../Images/icons/general/no-alcohol.svg';
import NoAlcohol2 from '../Images/icons/general/no-alcohol2.svg';
import NoSmoking from '../Images/icons/general/no-smoking.svg';
import NoVaccines from '../Images/icons/general/no-vaccines.svg';
import NoWaiting from '../Images/icons/general/no-waiting.svg';
import OfficeBuilding from '../Images/icons/general/office-building.svg';
import OilBarrelCustom from '../Images/icons/general/oil-barrel.svg';
import OilDrum from '../Images/icons/general/oil-drum.svg';
import OilPump from '../Images/icons/general/oil-pump.svg';
import OilTank from '../Images/icons/general/oil-tank.svg';
import OilTank2 from '../Images/icons/general/oil-tank2.svg';
import OxygenTank from '../Images/icons/general/oxygen-tank.svg';
import Petroleum from '../Images/icons/general/petroleum.svg';
import PieChartCustom from '../Images/icons/general/pie-chart.svg';
import Pier from '../Images/icons/general/pier.svg';
import Pier2 from '../Images/icons/general/pier2.svg';
import Plan from '../Images/icons/general/plan.svg';
import Plant from '../Images/icons/general/plant.svg';
import Poisonous from '../Images/icons/general/poisonous.svg';
import Port from '../Images/icons/general/port.svg';
import PortalCustom from '../Images/icons/general/portal.svg';
import Presentation from '../Images/icons/general/presentation.svg';
import Prevention from '../Images/icons/general/prevention.svg';
import Printer from '../Images/icons/general/printer.svg';
import Propeller from '../Images/icons/general/propeller.svg';
import RacingFlag from '../Images/icons/general/racing-flag.svg';
import RescueBoat from '../Images/icons/general/rescue-boat.svg';
import RoundedPlug from '../Images/icons/general/rounded-plug.svg';
import SafetyGoogles from '../Images/icons/general/safety-googles.svg';
import Sailor from '../Images/icons/general/sailor.svg';
import Satisfaction from '../Images/icons/general/satisfaction.svg';
import Sea from '../Images/icons/general/sea.svg';
import Sea2 from '../Images/icons/general/sea2.svg';
import SearchEngine2 from '../Images/icons/general/sertsenji.svg';
import ShieldCustom from '../Images/icons/general/shield.svg';
import Ship from '../Images/icons/general/ship.svg';
import SirenLight from '../Images/icons/general/siren-light.svg';
import Siren from '../Images/icons/general/siren.svg';
import StandBy from '../Images/icons/general/stand-by.svg';
import Statistics from '../Images/icons/general/statistics.svg';
import Stumble from '../Images/icons/general/stumble.svg';
import Tank from '../Images/icons/general/tank.svg';
import TowTruck from '../Images/icons/general/tow-truck.svg';
import TowerCrane from '../Images/icons/general/tower-crane.svg';
import ToxicSign from '../Images/icons/general/toxic-sign.svg';
import TrafficCone from '../Images/icons/general/traffic-cone.svg';
import TrafficData from '../Images/icons/general/traffic-data.svg';
import Training from '../Images/icons/general/training.svg';
import Trophy from '../Images/icons/general/trophy.svg';
import Turbine from '../Images/icons/general/turbine.svg';
import UpArrows from '../Images/icons/general/up-arrows.svg';
import User from '../Images/icons/general/user.svg';
import WarningCustom from '../Images/icons/general/warning.svg';
import WavesCustom from '../Images/icons/general/waves.svg';
import Waves2 from '../Images/icons/general/waves2.svg';
import Welder from '../Images/icons/general/welder.svg';
import WeldingMask from '../Images/icons/general/welding-mask.svg';
import WindRose from '../Images/icons/general/wind-rose.svg';
import WorkerCustom from '../Images/icons/general/worker.svg';
import WorldGrid from '../Images/icons/general/world-grid.svg';
import Worldwide from '../Images/icons/general/worldwide.svg';
import Wrench from '../Images/icons/general/wrench.svg';

// Job safety icons
import TrafficCone2 from '../Images/icons/job_safety_pack/001-traffic cone.svg';
import Coverall from '../Images/icons/job_safety_pack/002-coverall.svg';
import Respiratory from '../Images/icons/job_safety_pack/003-respiratory.svg';
import Cctv from '../Images/icons/job_safety_pack/004-cctv.svg';
import Bell2 from '../Images/icons/job_safety_pack/005-bell.svg';
import FireAlarm2 from '../Images/icons/job_safety_pack/006-fire alarm.svg';
import WarningSign from '../Images/icons/job_safety_pack/007-warning sign.svg';
import Radiation from '../Images/icons/job_safety_pack/008-radiation.svg';
import Crane2 from '../Images/icons/job_safety_pack/009-crane.svg';
import Gloves from '../Images/icons/job_safety_pack/010-gloves.svg';
import EarProtection from '../Images/icons/job_safety_pack/011-ear protection.svg';
import Hydrant2 from '../Images/icons/job_safety_pack/012-hydrant.svg';
import HealthCheck from '../Images/icons/job_safety_pack/013-health check.svg';
import HandWashing from '../Images/icons/job_safety_pack/014-hand washing.svg';
import Aerosol from '../Images/icons/job_safety_pack/015-Aerosol.svg';
import Whistle from '../Images/icons/job_safety_pack/016-whistle.svg';
import Safety from '../Images/icons/job_safety_pack/017-safety.svg';
import Apron from '../Images/icons/job_safety_pack/018-apron.svg';
import FaceProtection from '../Images/icons/job_safety_pack/019-face protection.svg';
import Boots2 from '../Images/icons/job_safety_pack/020-boots.svg';
import Gauge from '../Images/icons/job_safety_pack/021-gauge.svg';
import Binoculars2 from '../Images/icons/job_safety_pack/022-binoculars.svg';
import WaterHose from '../Images/icons/job_safety_pack/023-water hose.svg';
import Handrail from '../Images/icons/job_safety_pack/024-Handrail.svg';
import ProtectiveGloves from '../Images/icons/job_safety_pack/025-protective gloves.svg';
import Working from '../Images/icons/job_safety_pack/026-working.svg';
import StopCustom from '../Images/icons/job_safety_pack/027-stop.svg';
import Experiment from '../Images/icons/job_safety_pack/028-experiment.svg';
import Padlock from '../Images/icons/job_safety_pack/029-padlock.svg';
import LifePreserver from '../Images/icons/job_safety_pack/030-life preserver.svg';
import Safety2 from '../Images/icons/job_safety_pack/031-safety.svg';
import Emergency2 from '../Images/icons/job_safety_pack/032-emergency.svg';
import Protective from '../Images/icons/job_safety_pack/033-protective.svg';
import Pull from '../Images/icons/job_safety_pack/034-pull.svg';
import FirstAidCross from '../Images/icons/job_safety_pack/035-first aid cross.svg';
import WeldingMask2 from '../Images/icons/job_safety_pack/036-welding mask.svg';
import SmokeDetector from '../Images/icons/job_safety_pack/037-smoke detector.svg';
import Flashlight2 from '../Images/icons/job_safety_pack/038-flashlight.svg';
import Multimeter from '../Images/icons/job_safety_pack/039-Multimeter.svg';
import SeatBelt from '../Images/icons/job_safety_pack/040-seat belt.svg';
import ConstructionCustom from '../Images/icons/job_safety_pack/041-construction.svg';
import FaceMask from '../Images/icons/job_safety_pack/042-face mask.svg';
import Worker2 from '../Images/icons/job_safety_pack/043-worker.svg';
import Coverall2 from '../Images/icons/job_safety_pack/044-coverall.svg';
import GasMask2 from '../Images/icons/job_safety_pack/045-gas mask.svg';
import FireExtinguisher3 from '../Images/icons/job_safety_pack/046-fire extinguisher.svg';
import Boots from '../Images/icons/job_safety_pack/047-boots.svg';
import Barrier from '../Images/icons/job_safety_pack/048-barrier.svg';
import Flasher from '../Images/icons/job_safety_pack/049-flasher.svg';
import ReflectiveVest from '../Images/icons/job_safety_pack/050-reflective vest.svg';
//
import BackPain from '../Images/icons/job_safety_pack/back-pain.svg';
import Boat1 from '../Images/icons/job_safety_pack/Boat1.svg';
import EPIRB from '../Images/icons/job_safety_pack/EPIRB.svg';
import LifeBoat from '../Images/icons/job_safety_pack/Life Boat.svg';
import LifeRaft from '../Images/icons/job_safety_pack/Life Raft.svg';
import ManOverboard from '../Images/icons/job_safety_pack/Man Overboard.svg';
import Meter from '../Images/icons/job_safety_pack/Meter.svg';
import Nomobile from '../Images/icons/job_safety_pack/no-mobile.svg';
import RescueBoat2 from '../Images/icons/job_safety_pack/Rescue Boat.svg';
import Silence from '../Images/icons/job_safety_pack/silence.svg';
import Stop2 from '../Images/icons/job_safety_pack/STOP.svg';
import Stop3 from '../Images/icons/job_safety_pack/Stop2.svg';
import Toxic from '../Images/icons/job_safety_pack/Toxic.svg';
import Transponder from '../Images/icons/job_safety_pack/Transponder.svg';

// Office icons
import Commercial from '../Images/icons/office/commercial.svg';
import Communications from '../Images/icons/office/communications.svg';
import Enviromental1 from '../Images/icons/office/enviromental1.svg';
import Enviromental2 from '../Images/icons/office/enviromental2.svg';
import Finance from '../Images/icons/office/finance.svg';
import Finance2 from '../Images/icons/office/finance2.svg';
import It from '../Images/icons/office/IT.svg';
import Meeting from '../Images/icons/office/meeting.svg';
import Meetings1 from '../Images/icons/office/meetings1.svg';
import Mission from '../Images/icons/office/Mission.svg';
import Personnel from '../Images/icons/office/personnel.svg';
import Record from '../Images/icons/office/record.svg';
import RiskManagement from '../Images/icons/office/risk-management.svg';
import SecurityCustom from '../Images/icons/office/security.svg';
import Technical from '../Images/icons/office/technical.svg';

// Ship icons
import Appraisal from '../Images/icons/ship/appraisal.svg';
import Bulker2 from '../Images/icons/ship/Bulker2.svg';
import Bunkering from '../Images/icons/ship/bunkering.svg';
import Captain2 from '../Images/icons/ship/captain.svg';
import CargoBallast from '../Images/icons/ship/cargo_ballast.svg';
import Chemical from '../Images/icons/ship/Chemical.svg';
import CleanCustom from '../Images/icons/ship/Clean.svg';
import Compass3 from '../Images/icons/ship/Compass.svg';
import CyberSecurity2 from '../Images/icons/ship/cyber-security.svg';
import DeckOp from '../Images/icons/ship/deck_op.svg';
import Discharge from '../Images/icons/ship/Discharge.svg';
import Diver from '../Images/icons/ship/Diver.svg';
import Drill from '../Images/icons/ship/drill.svg';
import DrillsTrain from '../Images/icons/ship/drills_train.svg';
import Energy from '../Images/icons/ship/Energy.svg';
import EngineWatch from '../Images/icons/ship/eng_watch.svg';
import EngineOp from '../Images/icons/ship/engine-op.svg';
import FlangeGauge from '../Images/icons/ship/Flange-Gauge.svg';
import FlareCustom from '../Images/icons/ship/Flare.svg';
import Gauge2 from '../Images/icons/ship/Gauge.svg';
import Helicopter from '../Images/icons/ship/Helicopter.svg';
import Hierarchy3 from '../Images/icons/ship/hierarchy.svg';
import Ice from '../Images/icons/ship/ice.svg';
import Loading from '../Images/icons/ship/Loading.svg';
import LPG from '../Images/icons/ship/LPG.svg';
import Maintenance from '../Images/icons/ship/maintenance.svg';
import Manager from '../Images/icons/ship/manager.svg';
import NavigationCustom from '../Images/icons/ship/navigation.svg';
import OrganizationStructure from '../Images/icons/ship/organization-structure.svg';
import Paint from '../Images/icons/ship/Paint.svg';
import Plan2 from '../Images/icons/ship/Plan.svg';
import PlanningPer from '../Images/icons/ship/planning_per.svg';
import Pollution from '../Images/icons/ship/Pollution.svg';
import Pump from '../Images/icons/ship/Pump.svg';
import Purchasing from '../Images/icons/ship/purchasing.svg';
import RadarCustom from '../Images/icons/ship/Radar.svg';
import RadioCustom from '../Images/icons/ship/Radio.svg';
import SafetyManagement from '../Images/icons/ship/safety_manag.svg';
import Safeworking from '../Images/icons/ship/safeworking.svg';
import Tanker from '../Images/icons/ship/tanker.svg';
import Valve from '../Images/icons/ship/Valve.svg';
import Valve2 from '../Images/icons/ship/Valve2.svg';
import Welfare from '../Images/icons/ship/welfare.svg';

export function useIcon(props: any) {
  let icon;
  switch (props.iconName) {
    // All ranks icons
    case '2nd Engineer':
      icon = <Engineer2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case '2nd Officer':
      icon = <Officer2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case '3rd Engineer':
      icon = <Engineer3 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case '3rd Officer':
      icon = <Officer3 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case '4th Engineer':
      icon = <Engineer4 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Cadet':
      icon = <Cadet style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Captain':
      icon = <Captain style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Catering Officer':
      icon = (
        <CateringOfficer style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Chief Engineer':
      icon = (
        <ChiefEngineer style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Chief Officer':
      icon = (
        <ChiefOfficer style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Cook':
      icon = <Cook style={{ fill: props.color ? props.color : '#222' }} />;
      break;

    // General Icons
    case 'Gas 2':
      icon = <Gas2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Bell':
      icon = <Bell style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Basic Tick':
      icon = <BasicTick style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Oil Drum':
      icon = <OilDrum style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Fire Exit':
      icon = <FireExit style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Port':
      icon = <Port style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Welding Mask':
      icon = (
        <WeldingMask style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Flash':
      icon = <Flash style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Bad Feedback':
      icon = (
        <BadFeedback style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Petroleum':
      icon = <Petroleum style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Emergency Call 1':
      icon = (
        <EmergencyCall style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Pie Chart':
      icon = (
        <PieChartCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Search Engine':
      icon = (
        <SearchEngine2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'World Grid':
      icon = <WorldGrid style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Hierarchical Structure':
      icon = (
        <HierarchicalStructure
          style={{ fill: props.color ? props.color : '#222' }}
        />
      );
      break;
    case 'Leak':
      icon = <Leak style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Propeller':
      icon = <Propeller style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Traffic Data':
      icon = (
        <TrafficData style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Coal':
      icon = <Coal style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Global Services':
      icon = (
        <GlobalServices style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Training':
      icon = <Training style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Faucet':
      icon = <Faucet style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Hierarchy 2':
      icon = (
        <Hierarchy2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Office Building':
      icon = (
        <OfficeBuilding style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Lighthouse':
      icon = (
        <Lighthouse style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Electricity':
      icon = (
        <Electricity style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Compass2':
      icon = <WindRose style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Diesel':
      icon = <Diesel style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Caution':
      icon = <Caution style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Poisonous':
      icon = <Poisonous style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Inflatable Boat':
      icon = (
        <InflatableBoat style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Satisfaction':
      icon = (
        <Satisfaction style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Life Saver':
      icon = <Lifesaver style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Container':
      icon = (
        <ContainerCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Hydrant':
      icon = <Hydrant style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Sailor':
      icon = <Sailor style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Rounded Plug':
      icon = (
        <RoundedPlug style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Statistics':
      icon = (
        <Statistics style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Gas Mask':
      icon = <GasMask style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Accident':
      icon = <Accident style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Deal':
      icon = <Deal style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Wrench':
      icon = <Wrench style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Waves 2':
      icon = <Waves2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Safety Goggles':
      icon = (
        <SafetyGoogles style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Locations':
      icon = <Locations style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Portal':
      icon = (
        <PortalCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Fire':
      icon = <Fire style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Warning':
      icon = (
        <WarningCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Cogwheel':
      icon = <Cogwheel style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Presentation':
      icon = (
        <Presentation style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Ship':
      icon = <Ship style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Crane':
      icon = <Crane style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Fire Extinguisher 1':
      icon = (
        <FireExtinguisherCustom
          style={{ fill: props.color ? props.color : '#222' }}
        />
      );
      break;
    case 'Welder':
      icon = <Welder style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'City':
      icon = <City style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Trophy':
      icon = <Trophy style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Radioactive Barrel':
      icon = (
        <OilBarrelCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Captain Cap 2':
      icon = (
        <CaptainCap2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Prevention':
      icon = (
        <Prevention style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Oil Pump':
      icon = <OilPump style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Businessman':
      icon = (
        <Businessman style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Fire Extinguisher 2':
      icon = (
        <FireExtinguisher2
          style={{ fill: props.color ? props.color : '#222' }}
        />
      );
      break;
    case 'Load Crane':
      icon = (
        <CargoShip2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Helmet':
      icon = <Helmet style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Healthcare':
      icon = (
        <Healthcare style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'First Aid Kit':
      icon = (
        <FirstAidKit style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Printer':
      icon = <Printer style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Binoculars':
      icon = (
        <Binoculars style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'H2O':
      icon = <H2O style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Checked 1':
      icon = <Checked style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Freight':
      icon = <Freight style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Fuel':
      icon = <Fuel style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Pier 1':
      icon = <Pier style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Worldwide':
      icon = <Worldwide style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Emergency Call 2':
      icon = (
        <EmergencyCall2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Captain Cap 1':
      icon = (
        <CaptainCap style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Anchor':
      icon = (
        <AnchorCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Oil Tank 2':
      icon = <OilTank2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Siren Light':
      icon = (
        <SirenLight style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'House':
      icon = (
        <HouseCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Info Button 2':
      icon = <Info2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Stumble':
      icon = <Stumble style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Radiation Hazard':
      icon = <Biohazard style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'No Alcohol 2':
      icon = (
        <NoAlcohol2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Gas Station':
      icon = (
        <GasStation style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Graphic':
      icon = <Graphic style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'ID Card':
      icon = <IdCard style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Location':
      icon = (
        <LocationCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Oil Tank 1':
      icon = <OilTank style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Flashlight':
      icon = (
        <Flashlight style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Motor':
      icon = <Motor style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Buoy':
      icon = <Buoy style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Tower Crane':
      icon = (
        <TowerCrane style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Cyber Security':
      icon = (
        <CyberSecurity style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Pier 2':
      icon = <Pier2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Exit':
      icon = <Exit style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Siren':
      icon = <Siren style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Rescue Boat':
      icon = (
        <RescueBoat style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Racing Flag':
      icon = (
        <RacingFlag style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'BiologicalHazard':
      icon = (
        <BiologicalHazard
          style={{ fill: props.color ? props.color : '#222' }}
        />
      );
      break;
    case 'Shield':
      icon = (
        <ShieldCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Goods':
      icon = <UpArrows style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Fire Fighter 2':
      icon = (
        <Firefighter2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Life Vest':
      icon = <LifeVest style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Plan':
      icon = <Plan style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Construction Crane':
      icon = (
        <ConstructionCrane
          style={{ fill: props.color ? props.color : '#222' }}
        />
      );
      break;
    case 'Sea 1':
      icon = <Sea style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Internet':
      icon = <Internet style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Battery 2':
      icon = <Battery2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Tow Truck':
      icon = <TowTruck style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Feedback 1':
      icon = (
        <FeedbackCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Cone':
      icon = <Kone2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Mechanical Gears':
      icon = (
        <MechanicalGears style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Inspection':
      icon = (
        <Inspection style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Traffic Cone':
      icon = (
        <TrafficCone style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'No Vaccines':
      icon = (
        <NoVaccines style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Gasoline':
      icon = <Gasoline style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'HighVoltage':
      icon = (
        <HighVoltage style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Life Buoy':
      icon = <Lifebuoy style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Plant':
      icon = <Plant style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'BatteryStatusFull':
      icon = (
        <BatteryStatusFull
          style={{ fill: props.color ? props.color : '#222' }}
        />
      );
      break;
    case 'Businessmen':
      icon = (
        <Businessmen style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Chat Bubble':
      icon = (
        <ChatBubbleCustom
          style={{ fill: props.color ? props.color : '#222' }}
        />
      );
      break;
    case 'Medal':
      icon = <Medal style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'No Waiting':
      icon = <NoWaiting style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Radioactive':
      icon = <ToxicSign style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Oxygen Tank':
      icon = (
        <OxygenTank style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Worker':
      icon = (
        <WorkerCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Sea 2':
      icon = <Sea2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Emergency':
      icon = <Emergency style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Cargo Ship 1':
      icon = <CargoShip style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Idea':
      icon = (
        <IdeaCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'No Alcohol 1':
      icon = <NoAlcohol style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'User':
      icon = <User style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Hierarchy 1':
      icon = <Hierarchy style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Fire Fighter 1':
      icon = (
        <Firefighter style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Propeller 2':
      icon = <Turbine style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Leaf':
      icon = (
        <LeafCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Charity':
      icon = <Charity style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Fire Alarm':
      icon = <FireAlarm style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Stand By':
      icon = <StandBy style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Battery 1':
      icon = <Battery style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Waves 1':
      icon = (
        <WavesCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Megaphone':
      icon = <Megaphone style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Tank':
      icon = <Tank style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Feedback 2':
      icon = <Feedback2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Office Organisation':
      icon = <Boss style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Life Boat':
      icon = <Lifeboat style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Gas 1':
      icon = <Gas style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'No Smoking':
      icon = <NoSmoking style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Mooring Point':
      icon = (
        <MooringPoint style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Info Button 1':
      icon = (
        <InfoButton style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Bulletin':
      icon = <Bulletin style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Certificate':
      icon = (
        <Certificate style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'ChainBreak':
      icon = (
        <ChainBreak style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Checklist':
      icon = (
        <ChecklistCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'CO2':
      icon = <CO2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Collaborate':
      icon = (
        <Collaborate style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Documents':
      icon = <Documents style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Garbage':
      icon = <Garbage style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Guide':
      icon = <Guide style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Handbook':
      icon = <Handbook style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Like':
      icon = <Like style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Link':
      icon = <LinkIcon style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Lock':
      icon = (
        <LockCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Lock Tag':
      icon = <LockTag style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Manifold':
      icon = <Manifold style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Manual':
      icon = <Manual style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Manuals':
      icon = <Manuals style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Meeting 2':
      icon = <Meeting2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'NOx':
      icon = <NOx style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Order':
      icon = <Order style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Permit':
      icon = <Permit style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Policy2':
      icon = <Policy2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Poster':
      icon = <Poster style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Read':
      icon = <Read style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Recycle':
      icon = <Recycle style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Signature':
      icon = <Signature style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Strategy':
      icon = <Strategy style={{ fill: props.color ? props.color : '#222' }} />;
      break;

    // Job Safety icons
    case 'Back Pain':
      icon = <BackPain style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Boat 1':
      icon = <Boat1 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'EPIRB':
      icon = <EPIRB style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Life Boat2':
      icon = <LifeBoat style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Life Raft':
      icon = <LifeRaft style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Man Overboard':
      icon = (
        <ManOverboard style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Meter':
      icon = <Meter style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'No Mobile':
      icon = <Nomobile style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Rescue Boat 2':
      icon = (
        <RescueBoat2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Silence':
      icon = <Silence style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Stop 2':
      icon = <Stop2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Stop 3':
      icon = <Stop3 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Toxic':
      icon = <Toxic style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Transponder':
      icon = (
        <Transponder style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Radiation':
      icon = <Radiation style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Life Preserver':
      icon = (
        <LifePreserver style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Gauge':
      icon = <Gauge style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Stop':
      icon = (
        <StopCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Safety':
      icon = <Safety style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Flashlight 2':
      icon = (
        <Flashlight2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Reflective Vest':
      icon = (
        <ReflectiveVest style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Face Mask':
      icon = <FaceMask style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Coverall':
      icon = <Coverall style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Ear Protection':
      icon = (
        <EarProtection style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Traffic Cone 2':
      icon = (
        <TrafficCone2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'First Aid Cross':
      icon = (
        <FirstAidCross style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Crane 2':
      icon = <Crane2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Padlock':
      icon = <Padlock style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Seat Belt':
      icon = <SeatBelt style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Fire Alarm 2':
      icon = (
        <FireAlarm2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Experiment':
      icon = (
        <Experiment style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Coverall 2':
      icon = <Coverall2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Hydrant 2':
      icon = <Hydrant2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Flasher':
      icon = <Flasher style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Health Check':
      icon = (
        <HealthCheck style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Pull':
      icon = <Pull style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Hand Washing':
      icon = (
        <HandWashing style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Safety 2':
      icon = <Safety2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Respiratory':
      icon = (
        <Respiratory style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Construction':
      icon = (
        <ConstructionCustom
          style={{ fill: props.color ? props.color : '#222' }}
        />
      );
      break;
    case 'Apron':
      icon = <Apron style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Face Protection':
      icon = (
        <FaceProtection style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Water Hose':
      icon = <WaterHose style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Boots':
      icon = <Boots style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Gloves':
      icon = <Gloves style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Whistle':
      icon = <Whistle style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Bell 2':
      icon = <Bell2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Gas Mask 2':
      icon = <GasMask2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Binoculars 2':
      icon = (
        <Binoculars2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Cctv':
      icon = <Cctv style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Warning Sign':
      icon = (
        <WarningSign style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Smoke Detector':
      icon = (
        <SmokeDetector style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Aerosol':
      icon = <Aerosol style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Multimeter':
      icon = (
        <Multimeter style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Boots 2':
      icon = <Boots2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Emergency 2':
      icon = (
        <Emergency2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Barrier':
      icon = <Barrier style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Handrail':
      icon = <Handrail style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Welding Mask 2':
      icon = (
        <WeldingMask2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Tools':
      icon = <Working style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Protective Gloves':
      icon = (
        <ProtectiveGloves
          style={{ fill: props.color ? props.color : '#222' }}
        />
      );
      break;
    case 'Fire Extinguisher 3':
      icon = (
        <FireExtinguisher3
          style={{ fill: props.color ? props.color : '#222' }}
        />
      );
      break;
    case 'Protective':
      icon = (
        <Protective style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Worker 2':
      icon = <Worker2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;

    // Office Icons
    case 'Mission':
      icon = <Mission style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Communications':
      icon = (
        <Communications style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Enviromental 1':
      icon = (
        <Enviromental1 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Meetings 1':
      icon = <Meetings1 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Meeting':
      icon = <Meeting style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Personnel':
      icon = <Personnel style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Finance':
      icon = <Finance style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'IT':
      icon = <It style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Security':
      icon = (
        <SecurityCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Enviromental 2':
      icon = (
        <Enviromental2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Finance 2':
      icon = <Finance2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'RiskManagement':
      icon = (
        <RiskManagement style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Technical':
      icon = <Technical style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Record':
      icon = <Record style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Commercial':
      icon = (
        <Commercial style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;

    // Ship Icons
    case 'Bunkering':
      icon = <Bunkering style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'EngineOp':
      icon = <EngineOp style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Maintenance':
      icon = (
        <Maintenance style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Purchasing':
      icon = (
        <Purchasing style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Captain 2':
      icon = <Captain2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Manager':
      icon = <Manager style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Safety Management':
      icon = (
        <SafetyManagement
          style={{ fill: props.color ? props.color : '#222' }}
        />
      );
      break;
    case 'Organization Structure':
      icon = (
        <OrganizationStructure
          style={{ fill: props.color ? props.color : '#222' }}
        />
      );
      break;
    case 'Engine Watch':
      icon = (
        <EngineWatch style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Appraisal':
      icon = <Appraisal style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Planning Per':
      icon = (
        <PlanningPer style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Safeworking':
      icon = (
        <Safeworking style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Tanker':
      icon = <Tanker style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Navigation':
      icon = (
        <NavigationCustom
          style={{ fill: props.color ? props.color : '#222' }}
        />
      );
      break;
    case 'Cargo Ship1':
      icon = <CargoShip style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Cargo Ballast':
      icon = (
        <CargoBallast style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Cyber Security2':
      icon = (
        <CyberSecurity2 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Welfare':
      icon = <Welfare style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Drills Train':
      icon = (
        <DrillsTrain style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Deck Op':
      icon = <DeckOp style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Ice':
      icon = <Ice style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Hierarchy':
      icon = (
        <Hierarchy3 style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Bulker2':
      icon = <Bulker2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Chemical':
      icon = <Chemical style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Clean':
      icon = (
        <CleanCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Compass3':
      icon = <Compass3 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Discharge':
      icon = <Discharge style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Diver':
      icon = <Diver style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Drill':
      icon = <Drill style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Energy':
      icon = <Energy style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Flange-Gauge':
      icon = (
        <FlangeGauge style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Flare':
      icon = (
        <FlareCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Gauge2':
      icon = <Gauge2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Helicopter':
      icon = (
        <Helicopter style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Loading':
      icon = <Loading style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'LPG':
      icon = <LPG style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Paint':
      icon = <Paint style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Plan2':
      icon = <Plan2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Pollution':
      icon = <Pollution style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Pump':
      icon = <Pump style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Radar':
      icon = (
        <RadarCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Radio':
      icon = (
        <RadioCustom style={{ fill: props.color ? props.color : '#222' }} />
      );
      break;
    case 'Valve':
      icon = <Valve style={{ fill: props.color ? props.color : '#222' }} />;
      break;
    case 'Valve2':
      icon = <Valve2 style={{ fill: props.color ? props.color : '#222' }} />;
      break;

    // Misc Icons
    case 'Anchor 2':
      icon = <FaAnchor color={props.color ? props.color : '#222'} />;
      break;
    case 'Binoculars 3':
      icon = <FaBinoculars color={props.color ? props.color : '#222'} />;
      break;
    case 'Ice 2':
      icon = <GiIceBolt color={props.color ? props.color : '#222'} />;
      break;
    case 'Sea':
      icon = <GiAtSea color={props.color ? props.color : '#222'} />;
      break;
    case 'Crane 3':
      icon = <GiCrane color={props.color ? props.color : '#222'} />;
      break;
    case 'Peace':
      icon = <FaHandPeace color={props.color ? props.color : '#222'} />;
      break;
    case 'Valve':
      icon = <GiValve color={props.color ? props.color : '#222'} />;
      break;
    case 'GiRank2':
      icon = <GiRank2 color={props.color ? props.color : '#222'} />;
      break;
    case 'Teach':
      icon = <GiTeacher color={props.color ? props.color : '#222'} />;
      break;
    case 'People':
      icon = <IoIosPeople color={props.color ? props.color : '#222'} />;
      break;
    case 'Board':
      icon = <FaChalkboardTeacher color={props.color ? props.color : '#222'} />;
      break;
    case 'Sample':
      icon = <GiDrinkMe color={props.color ? props.color : '#222'} />;
      break;
    case 'FaLaptopCode':
      icon = <FaLaptopCode color={props.color ? props.color : '#222'} />;
      break;
    case 'Luggage Cart':
      icon = <FaLuggageCart color={props.color ? props.color : '#222'} />;
      break;
    case 'MdNotificationsActive':
      icon = (
        <MdNotificationsActive color={props.color ? props.color : '#222'} />
      );
      break;
    case 'Environmental':
      icon = <FaEnvira color={props.color ? props.color : '#222'} />;
      break;
    case 'FaClipboardList':
      icon = <FaClipboardList color={props.color ? props.color : '#222'} />;
      break;
    case 'Certified':
      icon = (
        <AiFillSafetyCertificate color={props.color ? props.color : '#222'} />
      );
      break;
    case 'InfoCircle':
      icon = <FaInfoCircle color={props.color ? props.color : '#222'} />;
      break;
    case 'Visual Alarm':
      icon = <RiAlarmWarningFill color={props.color ? props.color : '#222'} />;
      break;
    case 'Supervise':
      icon = <MdSupervisorAccount color={props.color ? props.color : '#222'} />;
      break;

    default:
      icon = <FaAnchor color={props.color ? props.color : '#222'} />;
      break;
  }

  return icon;
}
